import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export function useCourseContent(courseId) {
  const [lessons, setLessons] = useState({});
  const [grammatik, setGrammatik] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function fetchData() {
      try {
        const [lessonsRes, grammatikRes] = await Promise.all([
          fetch(`${API}/api/content/${courseId}/lessons`),
          fetch(`${API}/api/content/${courseId}/grammatik`)
        ]);

        if (cancelled) return;

        const lessonsData = await lessonsRes.json();
        const grammatikData = await grammatikRes.json();

        const lessonMap = {};
        (lessonsData.lessons || []).forEach(l => { lessonMap[l.key] = l.data; });
        setLessons(lessonMap);

        const gramMap = {};
        (grammatikData.grammatik || []).forEach(g => { gramMap[g.key] = g.data; });
        setGrammatik(gramMap);
      } catch (err) {
        console.warn(`Failed to load course content for ${courseId}:`, err);
        // Component will show loading/empty state
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchData();
    return () => { cancelled = true; };
  }, [courseId]);

  return { lessons, grammatik, loading };
}
